// src/sections/jobFest/JobFestHero.tsx
import React, { useEffect, useState } from "react";

// adjust paths if needed
import heroLeft from "../../assets/jobfest/jobfest-left.png";
import heroAvatar from "../../assets/jobfest/jobfest-avatar.png";

type TimeLeft = {
  days: string;
  hours: string;
  minutes: string;
  seconds: string;
};

const FEST_START = new Date("2025-12-13T00:00:00+05:30").getTime();

export const JobFestHero: React.FC = () => {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>({
    days: "00",
    hours: "00",
    minutes: "00",
    seconds: "00",
  });

  useEffect(() => {
    const updateCountdown = () => {
      const now = new Date().getTime();
      const distance = FEST_START - now;

      const days = Math.max(0, Math.floor(distance / (1000 * 60 * 60 * 24)));
      const hours = Math.max(
        0,
        Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        )
      );
      const minutes = Math.max(
        0,
        Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
      );
      const seconds = Math.max(
        0,
        Math.floor((distance % (1000 * 60)) / 1000)
      );

      setTimeLeft({
        days: String(days).padStart(2, "0"),
        hours: String(hours).padStart(2, "0"),
        minutes: String(minutes).padStart(2, "0"),
        seconds: String(seconds).padStart(2, "0"),
      });
    };

    updateCountdown();
    const id = setInterval(updateCountdown, 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <header className="hero">
      {/* Left background graphic */}
      <img
        src={heroLeft}
        alt="AI hiring flow background"
        className="hero-bg-left"
      />

      {/* Right avatar bubble */}
      <div className="hero-bg-right">
        <div className="hero-avatar-wrap">
          <img
            src={heroAvatar}
            alt="AI candidate"
            className="hero-avatar"
          />
        </div>
      </div>

      {/* Centered content */}
      <div className="hero-inner">
        <div className="hero-tag">Babblebots Job Fest – AI Talent</div>

        <h1 className="hero-title">
          Hire and get hired in one AI Talent Fest.
        </h1>

        <div className="countdown">
          <div className="countdown-label">AI Interview Fest starts in</div>
          <div className="countdown-grid">
            <div className="count-box">
              <span className="count-number">{timeLeft.days}</span>
              <span className="count-text">Days</span>
            </div>
            <div className="count-box">
              <span className="count-number">{timeLeft.hours}</span>
              <span className="count-text">Hours</span>
            </div>
            <div className="count-box">
              <span className="count-number">{timeLeft.minutes}</span>
              <span className="count-text">Minutes</span>
            </div>
            <div className="count-box">
              <span className="count-number">{timeLeft.seconds}</span>
              <span className="count-text">Seconds</span>
            </div>
          </div>
        </div>

        <p className="hero-subtitle">
          One 15-minute AI interview that ranks talent across companies.
          Move from shortlists to offers between{" "}
          <strong>8–19 December 2025</strong>.
        </p>

        <div className="hero-cta-row">
          <a href="https://calendly.com/sales-babblebots/babblebots-discovery" className="hero-cta hero-cta--primary">
            I want to hire AI talent
          </a>
          <a href="https://forms.gle/VYe6GSe7ocNnsRmJ6" className="hero-cta hero-cta--ghost">
            I want to apply for AI roles
          </a>
        </div>
      </div>
    </header>
  );
};
